import { createAxiosClient } from "@ntg/component-library/utilities";
import { useMutation } from "@tanstack/react-query";

const apiClient = createAxiosClient("D365FO");

interface ICommitBomToManufacturingPayload {
    designID: number;
    mItemID: number;
}

async function commitBomToManufacturing(
    payload: ICommitBomToManufacturingPayload,
): Promise<string> {
    const response = await apiClient.post<string>(
        "/FunctionAppsStarter/CommitBomToManufacturing",
        payload,
    );
    return response.data;
}

export function useCommitBomToManufacturing() {
    return useMutation({
        mutationFn: commitBomToManufacturing,
    });
}
